module.exports = __webpack_public_path__ + "img/Group2343424.625f679b.png";